import global_axios from '../../funciones_globales/interaccionapi';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import { CARGAR_EGRESOBODEGA } from './actionTypes';
import { completar_String } from '../../funciones_globales/format';
import { generarItemCatalogoSeleccionado } from '../../funciones_globales/catalogos';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_ValoresIniciales = (fechaProceso) => {
	return (dispatch) => {
		return global_axios({
			url: '/secuenciales/Egreso',			
			method: 'GET',			
		})	
		.then( response => {						
			let cod_secuencial = completar_String(response.data.codigo, '0', 6);					
			dispatch({
				type: INICIALIZAR_FORM,
				data: {	codigo: cod_secuencial,						
						fecha: fechaProceso
					}			
			})
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar valores iniciales de egreso de bodega', mensaje: msgError}
			});
		});
	}
}

export const cargar_EgresoBodega = (cod_egreso) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/egresosbodega/' + cod_egreso,			
			method: 'GET'			
		})			
		.then( response => {
			let egresoBod = response.data;
			egresoBod.tipo = (egresoBod.tipoEg===null?null:generarItemCatalogoSeleccionado(egresoBod.tipoEg.Codigo, egresoBod.tipoEg.Descripcion));
			egresoBod.proveedor = (egresoBod.prov===null?null:generarItemCatalogoSeleccionado(egresoBod.prov.Codigo, egresoBod.prov.Nombre));

			dispatch({
				type: CARGAR_EGRESOBODEGA,
				data: egresoBod		
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar egreso de bodega', mensaje: msgError}
			});
		});
	}
}